import { OrganizationContractType } from '../../../../models/enums/ContractType';
import { getOptionsFromEnum } from '../../../../utils/getOptionsFromEnum';

export const contractTypeOptions = getOptionsFromEnum(
  OrganizationContractType,
  'contract-type',
);
